import { Image, Text } from "@sundae/ui-toolkit";
import { FC, useCallback } from "react";
import { useIsWalletConnected } from "../../../../../../hooks/useIsWalletConnected";
import { DisconnectedWallet } from "../../../../DisconnectedWallet";

const ProvideLiquidityGuideStep1Title: FC = () => {
  const isWalletConnected = useIsWalletConnected();

  const renderMemoizedNode = useCallback(() => {
    if (!isWalletConnected) {
      return <DisconnectedWallet.Title />;
    }

    return (
      <div className="grid gap-4">
        <div className="overflow-hidden rounded-lg">
          <Image
            className="mx-auto"
            src="https://media.giphy.com/media/8ENiS6ejIUlvK16Jwp/giphy.gif"
            width={500}
            height={315}
          />
        </div>
        <Text className="text-center" tag="h1" size="3xl" weight="semibold">
          Provide Liquidity like a Pro
        </Text>
      </div>
    );
  }, [isWalletConnected]);

  return renderMemoizedNode();
};

export default ProvideLiquidityGuideStep1Title;
